import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { fcfa, imgUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function CartPage() {
  const { items, update, remove, total, keyOf } = useCart();
  const nav = useNavigate();
  if (!items.length)
    return (
      <div data-testid="cart-empty" className="mx-auto max-w-xl px-4 py-20 text-center">
        <ShoppingBag className="mx-auto h-12 w-12 text-orange-300" />
        <h1 className="mt-4 font-display text-3xl font-black">Votre panier est vide</h1>
        <Button asChild className="mt-6 rounded-full"><Link to="/recherche">Découvrir les produits</Link></Button>
      </div>
    );
  return (
    <div data-testid="cart-page" className="mx-auto grid max-w-6xl gap-8 px-4 py-8 md:grid-cols-[1fr_340px] md:px-6">
      <div>
        <h1 className="mb-6 font-display text-3xl font-black tracking-tight">Panier</h1>
        <div className="space-y-3">
          {items.map((i) => {
            const k = keyOf(i);
            return (
              <div key={k} data-testid={`cart-item-${i.product_id}`} className="flex gap-4 rounded-xl border bg-white p-3">
                <img src={imgUrl(i.image)} alt="" className="h-20 w-20 rounded-lg object-cover" />
                <div className="min-w-0 flex-1">
                  <Link to={`/produit/${i.product_id}`} className="line-clamp-2 font-semibold">{i.title}</Link>
                  <p className="text-xs text-gray-500">{i.shop_name}{i.variant ? ` · ${i.variant}` : ""}</p>
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center rounded-full ring-1 ring-gray-200">
                      <button className="p-1.5" data-testid={`cart-minus-${i.product_id}`} onClick={() => update(k, Math.max(1, i.quantity - 1))}><Minus className="h-3 w-3" /></button>
                      <span className="tnum w-7 text-center text-sm font-bold">{i.quantity}</span>
                      <button className="p-1.5" data-testid={`cart-plus-${i.product_id}`} onClick={() => update(k, Math.min(i.stock, i.quantity + 1))}><Plus className="h-3 w-3" /></button>
                    </div>
                    <span className="tnum font-bold">{fcfa(i.price * i.quantity, i.currency)}</span>
                  </div>
                </div>
                <button data-testid={`cart-remove-${i.product_id}`} onClick={() => remove(k)} className="self-start p-1 text-gray-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
              </div>
            );
          })}
        </div>
      </div>
      <aside className="h-fit space-y-4 rounded-2xl border bg-white p-5 md:sticky md:top-24">
        <h2 className="font-display text-xl font-bold">Récapitulatif</h2>
        <div className="flex justify-between text-sm"><span>Sous-total</span><span data-testid="cart-subtotal" className="tnum font-bold">{fcfa(total, items[0]?.currency)}</span></div>
        <p className="text-xs text-gray-500">Les frais de livraison sont calculés à l'étape suivante selon votre zone.</p>
        <Button className="w-full rounded-full" size="lg" data-testid="cart-checkout-btn" onClick={() => nav("/commande")}>Passer la commande</Button>
      </aside>
    </div>
  );
}
